'use strict';
import classNames from 'classnames';
import isString from 'lodash/isString';
import moment from 'moment';
import * as T from 'prop-types';
import React from 'react';
import {PeopleItem} from '../../../personnel/components/PeopleItem';
import {isDateLabel} from "../../enums/DateLabel";


export function TaskAssignmentView(props) {
  const date = props.date ? moment(props.date) : null;
  const dateMsg = date ? date.format('ll') : props.notScheduledLabel;
  const timeMsg = date ? date.format('LT') : '';

  return (
    <div
      className={classNames("TaskAssignment", props.className)}
      onClick={props.onClick}
    >
      <i className={'TaskAssignment__calendarIcon icon ' + props.iconClass} />

      <div className="TaskAssignment__schedule">
        <span className="TaskAssignment__schedule__date">
          {dateMsg}
        </span>
        {props.useTime ? (
          <span className="TaskAssignment__schedule__time">
            {`${isString(props.timeLabel) ? props[props.timeLabel] : ''} ${timeMsg}`}
          </span>
        ) : null}
      </div>

      <PeopleItem
        className="TaskAssignment__person"
        avatarWidth={29}
        avatarHeight={29}
        avatarDisplayWidth={28}
        avatarDisplayHeight={28}
        rtl={true}
        showName={props.showTargetName}
        isSimple={true}
        model={props.target}
        nullLabel="tasks.properties.assignedTo.null.message"

        init={props.init}
      />
    </div>
  );
}

TaskAssignmentView.propTypes = {
  className: T.string,
  iconClass: T.string,
  showTargetName: T.bool,
  date: T.oneOfType([
    T.number,
    T.instanceOf(Date),
  ]),
  useTime: T.bool,

  timeLabel: isDateLabel,
  atLabel: T.string,
  byLabel: T.string,
  notScheduledLabel: T.string,

  onClick: T.func,
};

TaskAssignmentView.messages = [
  {code: 'tasks.schedule.by.time.label', prop: 'byLabel'},
  {code: 'tasks.status.at.time.label', prop: 'atLabel'},
  {code: 'schedule.not_scheduled.label', prop: 'notScheduledLabel'},
];

TaskAssignmentView.messageProps = [
  'byLabel',
  'atLabel',
  'notScheduledLabel',
];



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskAssignment/TaskAssignmentView.js